// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Using a .css file is a special case here, because it's impossible to target
 * pseudo-elements from js code (e.g. ::-webkit)
 * It also helps in cases like using the Datepicker in Storybook - the styles are imported
 * with the component
 */

.expensify-datepicker::-webkit-calendar-picker-indicator {
    color-scheme: dark;
    cursor: pointer;
    padding: 18px 13px;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
}
.expensify-datepicker::-webkit-date-and-time-value {
    text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/components/DatePicker/styles.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,2BAA2B;AAC/B;AACA;IACI,gBAAgB;AACpB","sourcesContent":["/**\n * Using a .css file is a special case here, because it's impossible to target\n * pseudo-elements from js code (e.g. ::-webkit)\n * It also helps in cases like using the Datepicker in Storybook - the styles are imported\n * with the component\n */\n\n.expensify-datepicker::-webkit-calendar-picker-indicator {\n    color-scheme: dark;\n    cursor: pointer;\n    padding: 18px 13px;\n    position: absolute;\n    right: 0;\n    top: 50%;\n    transform: translateY(-50%);\n}\n.expensify-datepicker::-webkit-date-and-time-value {\n    text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
